<script>
import { mapGetters } from 'vuex';
import MentionBox from '../mentions/MentionBox.vue';

export default {
  components: { MentionBox },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
    inboxId: {
      type: [Number, String],
      default: null,
    },
  },
  emits: ['replace'],
  computed: {
    ...mapGetters({
      cannedMessages: 'getCannedResponses',
      accountId: 'getCurrentAccountId',
    }),
    normalizedInboxId() {
      const parsedInboxId = Number(this.inboxId);
      return Number.isFinite(parsedInboxId) && parsedInboxId > 0
        ? parsedInboxId
        : null;
    },
    filteredCannedMessages() {
      if (!this.normalizedInboxId) {
        return this.cannedMessages;
      }

      return this.cannedMessages.filter(cannedMessage => {
        const inboxIds = Array.isArray(cannedMessage?.inbox_ids)
          ? cannedMessage.inbox_ids.map(id => Number(id)).filter(Boolean)
          : [];

        return inboxIds.includes(this.normalizedInboxId);
      });
    },
    items() {
      return this.filteredCannedMessages.map(cannedMessage => ({
        label: cannedMessage.short_code,
        key: cannedMessage.short_code,
        description: cannedMessage.content,
      }));
    },
  },
  watch: {
    searchKey() {
      this.fetchCannedResponses();
    },
    inboxId() {
      this.fetchCannedResponses();
    },
  },
  mounted() {
    this.fetchCannedResponses();
  },
  methods: {
    fetchCannedResponses() {
      const normalizedSearchKey = String(this.searchKey || '')
        .replace(/^\//, '')
        .trim();

      this.$store.dispatch('getCannedResponse', {
        searchKey: normalizedSearchKey || undefined,
        inboxId: this.inboxId,
      });
    },
    handleMentionClick(item = {}) {
      this.$emit('replace', item.description);
    },
    handleHeaderAction() {
      const targetRoute = this.$router.resolve({
        name: 'canned_list',
        params: { accountId: this.accountId },
      });
      window.location.assign(targetRoute.href);
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <MentionBox
    v-if="items.length"
    :items="items"
    header-title="Respostas rápidas"
    :show-header-action="true"
    header-action-label="Editar respostas prontas"
    @mention-select="handleMentionClick"
    @header-action="handleHeaderAction"
  />
</template>
